import script from "./scoreType1.vue?vue&type=script&setup=true&lang=js"
export * from "./scoreType1.vue?vue&type=script&setup=true&lang=js"

import "./scoreType1.vue?vue&type=style&index=0&id=aaab02e8&lang=less&scoped=true"

import exportComponent from "/data/home/csserver/project/cpcps/h5fe_cpcps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aaab02e8"]])

export default __exports__